"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pDefer = _interopRequireDefault(require("./external/p-defer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var EventAsPromise = /*#__PURE__*/function () {
  function EventAsPromise() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EventAsPromise);

    this.defers = [];
    this.upcomingDeferred = null;
    this.eventListener = this.eventListener.bind(this);
    this.options = options;
    this.one = this.one.bind(this);
    this.upcoming = this.upcoming.bind(this);

    this[Symbol.iterator] = function () {
      return {
        next: function next() {
          return {
            done: false,
            value: _this.upcoming()
          };
        }
      };
    };
  }

  _createClass(EventAsPromise, [{
    key: "eventListener",
    value: function eventListener(event) {
      var deferred = this.defers.shift();
      var args = this.options.array ? [].slice.call(arguments) : event;
      deferred && deferred.resolve(args);

      if (this.upcomingDeferred) {
        this.upcomingDeferred.resolve(args);
        this.upcomingDeferred = null;
      }
    }
  }, {
    key: "one",
    value: function one() {
      var deferred = (0, _pDefer.default)();
      this.defers.push(deferred);
      return deferred.promise;
    }
  }, {
    key: "upcoming",
    value: function upcoming() {
      if (!this.upcomingDeferred) {
        this.upcomingDeferred = (0, _pDefer.default)();
      }

      return this.upcomingDeferred.promise;
    }
  }]);

  return EventAsPromise;
}();

exports.default = EventAsPromise;
module.exports = exports.default;
module.exports.default = exports.default;